import { render, staticRenderFns } from "./BuddyBotAPI.vue?vue&type=template&id=6b2999ed&scoped=true"
import script from "./BuddyBotAPI.vue?vue&type=script&lang=js"
export * from "./BuddyBotAPI.vue?vue&type=script&lang=js"
import style0 from "./BuddyBotAPI.vue?vue&type=style&index=0&id=6b2999ed&prod&lang=css"
import style1 from "./BuddyBotAPI.vue?vue&type=style&index=1&id=6b2999ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2999ed",
  null
  
)

export default component.exports